import api from './api';

const USER_PREFERENCES_URL = '/userPreferences';

export const userPreferencesApi = api.injectEndpoints({
  endpoints: (build) => ({
    // Farms
    getFavouriteFarmIds: build.query<string[], void>({
      query: () => ({
        url: `${USER_PREFERENCES_URL}/favoriteFarms`,
      }),
      providesTags: ['FavouriteFarms'],
    }),

    addFavouriteFarm: build.mutation<void, string>({
      query: (farmId) => ({
        url: `${USER_PREFERENCES_URL}/favoriteFarm`,
        method: 'POST',
        params: { farmId },
      }),
      invalidatesTags: ['FavouriteFarms'],
    }),

    removeFavouriteFarm: build.mutation<void, string>({
      query: (farmId) => ({
        url: `${USER_PREFERENCES_URL}/favoriteFarm`,
        method: 'DELETE',
        params: { farmId },
      }),
      invalidatesTags: ['FavouriteFarms'],
    }),

    // Hub devices
    getFavouriteHubDeviceIds: build.query<string[], void>({
      query: () => ({
        url: `${USER_PREFERENCES_URL}/favoriteHubDevices`,
      }),
      providesTags: ['FavouriteHubDevices'],
    }),

    addFavouriteHubDevice: build.mutation<void, string>({
      query: (serialNumber) => ({
        url: `${USER_PREFERENCES_URL}/favoriteHubDevice`,
        method: 'POST',
        params: { serialNumber },
      }),
      invalidatesTags: ['FavouriteHubDevices'],
    }),

    removeFavouriteHubDevice: build.mutation<void, string>({
      query: (duid) => ({
        url: `${USER_PREFERENCES_URL}/favoriteHubDevice`,
        method: 'DELETE',
        params: { duid },
      }),
      invalidatesTags: ['FavouriteHubDevices'],
    }),
  }),
});

export const {
  useAddFavouriteFarmMutation,
  useRemoveFavouriteFarmMutation,
  useGetFavouriteFarmIdsQuery,
  useAddFavouriteHubDeviceMutation,
  useRemoveFavouriteHubDeviceMutation,
  useGetFavouriteHubDeviceIdsQuery,
} = userPreferencesApi;
